import React from 'react'
import { Message } from 'src/core/models'
import { FormLabels, CustomText } from 'src/components'
import MessageItemAction from '../MessageItemAction/MessageItemAction'
import { getTransformedDate } from 'src/core/helpers'


const MessageColumnMovileView: React.FC<{ message: Message }> = ({ message }) => {
  const fromText = message.system ? 'ClimateTrade' : message.is_anonymous_user ? message.anonymous_sender_email :  `${message.sender_name} ${message.sender_lastname}`
  return <>
    <FormLabels
      title={fromText}
      subtitle={message.subject}
    />
    <div className='flex-space-between'>
      <CustomText label={getTransformedDate(message.date)} />
      <MessageItemAction message={message} />
    </div>
  </>
}

export default MessageColumnMovileView
